import { defineProperty as _defineProperty } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { cleanupClassObject } from '../../utils/DomUtils.js';
import { Host } from '../../utils/Host.js';
import { fComp } from '../../utils/React.js';
import { hostClass } from '../Section/Section.styles.js';

var SectionContentPresentation = fComp(function (props) {
  var _cleanupClassObject;
  var children = props.children,
    className = props.className;
  return /*#__PURE__*/React.createElement(Host, {
    className: cleanupClassObject((_cleanupClassObject = {}, _defineProperty(_cleanupClassObject, className, className), _defineProperty(_cleanupClassObject, "".concat(hostClass, "-content"), true), _cleanupClassObject))
  }, children);
});
SectionContentPresentation.displayName = "SectionContentPresentation";

export { SectionContentPresentation };
